import React from 'react';

import { Table } from '..';
import { ExpandIcon } from './ExpandIcon';
import { HeaderRow } from './HeaderRow';

/** @type {React.FC<import('antd/lib/table').TableProps>} */
const ExpandAllTable = ({ dataSource = [], columns, rowKey, ...rest }) => {
  const [expandedKeys, setExpandedKeys] = React.useState([]);

  const toggleExpandAll = React.useCallback(
    allExpanded => (allExpanded ? setExpandedKeys(dataSource.map(item => item[rowKey])) : setExpandedKeys([])),
    [dataSource, rowKey]
  );

  const renderHeaderRow = React.useCallback(
    props => <HeaderRow {...props} onExpand={toggleExpandAll} />,
    [toggleExpandAll]
  );

  return (
    <div className="table-container">
      <Table
        rowKey={rowKey}
        columns={columns}
        expandIcon={ExpandIcon}
        dataSource={dataSource}
        expandedRowKeys={expandedKeys}
        onExpandedRowsChange={setExpandedKeys}
        components={{
          header: {
            row: renderHeaderRow,
          },
        }}
        {...rest}
      />
    </div>
  );
};

export default ExpandAllTable;
